import {connect} from 'react-redux';
import {TransferList} from "./List/TransferList";
import {actions} from '../../js/redux/transfer';
import {CreateTransfer} from "./Create/CreateTransfer";


const TransferState = (state) => {
  return {
    ...state.transfer,
  };
};


const CreateTransferConn = connect(TransferState, actions)(CreateTransfer);
const TransferListConn = connect(TransferState, actions)(TransferList);

export {
  TransferListConn,
  CreateTransferConn
}